import { useCallback, useEffect, useRef } from "react"

const extractRef = (ref) => ("current" in ref ? ref.current : ref)

const isDescendant = (node, target) =>
  (node && node.contains(target)) || node === target

export default function useHandleOutsideClick({
  onOutsideClick,
  ref,
  enabled = true,
  shards = [],
}) {
  const outsideClickRef = useRef(false)

  const isInsideClick = useCallback(
    (e) =>
      [ref, ...shards].some((ref) => {
        const el = extractRef(ref)
        return el && isDescendant(el, e.target)
      }),
    [ref, shards]
  )

  const handleMouseDown = useCallback(
    (e) => {
      outsideClickRef.current = enabled && !isInsideClick(e)
    },
    [enabled, isInsideClick]
  )

  const handleMouseUp = useCallback(
    (e) => {
      if (
        outsideClickRef.current &&
        enabled &&
        !isInsideClick(e) &&
        onOutsideClick
      ) {
        outsideClickRef.current = false
        onOutsideClick()
      }
    },
    [enabled, isInsideClick, onOutsideClick]
  )

  useEffect(() => {
    window.addEventListener("mousedown", handleMouseDown)
    window.addEventListener("mouseup", handleMouseUp)

    return () => {
      window.removeEventListener("mousedown", handleMouseDown)
      window.removeEventListener("mouseup", handleMouseUp)
    }
  }, [enabled, onOutsideClick, ref, shards])

  return null
}
